var _Mask, _G;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import Svg, { Mask, Path, G } from "react-native-svg";
function SvgCheckboxMarked(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "#A6A6A6",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _Mask || (_Mask = /*#__PURE__*/React.createElement(Mask, {
    id: "checkbox-marked_svg__a",
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 18,
    height: 18
  }, /*#__PURE__*/React.createElement(Path, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 3h14a2 2 0 012 2v14a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2zm0 9l5 5 9-9-1.41-1.42L10 14.17l-3.59-3.58L5 12z",
    fill: "#fff"
  }))), _G || (_G = /*#__PURE__*/React.createElement(G, {
    mask: "url(#checkbox-marked_svg__a)"
  }, /*#__PURE__*/React.createElement(Path, {
    d: "M0 0h24v24H0z"
  }))));
}
export default SvgCheckboxMarked;